// @flow
import * as types from "../constants/action-types";
import initialState from "./initial-state";
import * as R from "ramda";


export const settingsReducer = R.cond([
    [
        (state, action) => (action.type === types.UPDATE_SETTINGS_SUCCESS),
        (state, action) => ({
            ...state,
            data: { ...state.data, ...action.payload.data },
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.UPDATE_SETTINGS_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        R.T,
        state => (state || initialState.settings)
    ]
]);
